var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.371241 11.0671L10.6382 0.386228C11.1331 -0.128743 11.9361 -0.128743 12.4311 0.386228L13.6287 1.63216C14.1232 2.14658 14.1237 2.97977 13.6308 3.49529L5.49387 11.9997L13.6303 20.5047C14.1237 21.0202 14.1226 21.8534 13.6282 22.3678L12.4306 23.6138C11.9356 24.1287 11.1326 24.1287 10.6376 23.6138L0.371241 12.9324C-0.123747 12.4174 -0.123747 11.582 0.371241 11.0671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowBack);
export default __webpack_public_path__ + "static/media/ic-arrow-back.7ca76f7c9bd5b0f8ae17ec05849b3df1.svg";
export { ForwardRef as ReactComponent };